<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Pases')"
      icono="mdi-badge-account-horizontal"
      tabla="pas"
      busqueda-rapida
      :campos="['id_pas-', 'id_empinq', 'nomape+', 'nif-', 'dom-', 'codpos-', 'pob-', 'pro-', 'corele-', 'tel1-', 'tel2-', 'obs-', 'fecalt-', 'id_tippas', 'id_estpre', 'id_zon_pre-', 'ultmov', 'inival', 'finval', 'blo-', 'apb-', 'numpla', 'saldis-', 'lismat', 'ultent-', 'ultsal-', 'ultpag-', 'conuso-']"
      :campos-filtrables="['id_empinq', 'id_tippas', 'id_estpre', 'blo', 'id_zon_pre', 'ultmov']"
      :titulo-crud="$t ('pase')"
      campo-sujeto-accion="nomape"
      alto-minimo-ventana="520"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
      :evento-antes-abrir-formulario-datos="antesAbrirFormularioDatosPase"
      :evento-despues-guardar-formulario-datos="despuesGuardarFormularioDatosPase"
      :formulario-datos-api-props="{ anchoMaximo: '950', sinMargenes: true }"
      @montado="montadoTablaDatos"
    >
      <!-- C O L U M N A S   T A B L A -->

      <template v-slot:[`item.id_empinq__VT`]="{ item }">
        {{ item.id_empinq ? $tablasConsulta.registroPorClave ('empinq', item.id_empinq, 'nom') : $t ('(Ninguna)') }}
      </template>

      <template v-slot:[`item.inival__VT`]="{ item }">
        <span v-if="esFechaHoraFutura (item.inival)" style="color: #EE9010">{{ item.inival__VT }}</span>
        <span v-else>{{ item.inival__VT }}</span>
      </template>

      <template v-slot:[`item.finval__VT`]="{ item }">
        <span v-if="esFechaHoraPasada (item.finval)" style="color: #EE1010">{{ item.finval__VT }}</span>
        <span v-else>{{ item.finval__VT }}</span>
      </template>

      <template v-slot:[`item.lismat`]="{ item }">
        <template v-if="item.lismat">
          <span class="d-flex flex-wrap">
          <span v-for="(matricula, idx) in item.lismat.split (',')" :key="idx" class="matricula">{{ matricula }}</span>
          </span>
        </template>
      </template>

      <template v-slot:[`item.id_estpre__VT`]="{ item }">
          <span v-if="item.id_estpre==0" style="color: #AAAAAA"><v-icon color="#AAAAAA">mdi-map-marker-question</v-icon><span class="ml-1">{{ item.id_estpre__VT }}</span></span>
          <span v-else-if="item.id_estpre==1" style="color: #50779f"><v-icon color="#50779f">mdi-map-marker-remove</v-icon><span class="ml-1">{{ item.id_estpre__VT }}</span></span>
          <span v-else-if="item.id_estpre==2" style="color: #9f509f"><v-icon color="#9f509f">mdi-map-marker-path</v-icon><span class="ml-1">{{ item.id_estpre__VT }}</span></span>
          <span v-else-if="item.id_estpre==3" style="color: #509F50" class="mr-2"><v-icon color="#509F50">mdi-map-marker-radius</v-icon><span class="ml-1">{{ item.id_estpre__VT }}</span></span>
          <span v-else style="color: orange"><v-icon>mdi-circle</v-icon><span class="ml-1">{{ item.id_estpre__VT }}</span></span>
          <span v-if="item.blo!=0" class="ml-2" style="color: orange"><v-icon color="orange">mdi-lock</v-icon><span class="ml-1">Bloqueado</span></span>
          <div v-else-if="item.id_estpre==3" class="d-inline-block ml-1 text-caption">{{ item.id_zon_pre__VT }}</div>
      </template>

      <template v-slot:[`item.saldis`]="{ item }">
        {{ literalSaldoProducto (item.saldis, item.tipsal) }}
      </template>

      <!-- F O R M U L A R I O -->

      <template v-slot:default="{ definicionCampos, datosRegistro, accionCrud, esAccionEliminar }">
        <v-tabs v-model="tab" fixed-tabs background-color="#E0E0D0" mobile-breakpoint="0">
          <!-- <v-tabs-slider color="red"></v-tabs-slider> -->
          <v-tab>
            <v-icon class="mr-3">mdi-account-box</v-icon>{{ $t ('Titular') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-card-bulleted-settings</v-icon>{{ $t ('Propiedades') }}
          </v-tab>
          <v-tab v-if="registro_tipo_pase && registro_tipo_pase.tipren > 0">
            <v-icon class="mr-3">mdi-calendar-range</v-icon>{{ $t ('Renovaciones') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-arrow-left-right-bold</v-icon>{{ $t ('Registro de eventos') }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless>

          <!-- T I T U L A R  -->
          <v-tab-item transition="scroll-x-transition" eager>
            <v-container class="mt-5 px-6">
              <v-row no-gutters>
                <v-col cols="5">
                  <CampoFormularioDatos v-if="definicionCampos['id_empinq'].visibilidad==''" nombre-campo="id_empinq" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="'D'.includes (accionCrud)" @change="changeSelectEmpresaInquilina" />
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-2">
                <v-col cols="4" class="pr-6">
                  <CampoFormularioDatos nombre-campo="nom" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
                <v-col cols="5" class="pr-6">
                  <CampoFormularioDatos nombre-campo="ape" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
                <v-col cols="3">
                  <CampoFormularioDatos nombre-campo="nif" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="7" class="pr-6">
                  <CampoFormularioDatos nombre-campo="dom" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
                <v-col cols="5">
                  <CampoFormularioDatos nombre-campo="pob" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="3" class="pr-6">
                  <CampoFormularioDatos nombre-campo="codpos" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
                <v-col cols="5" class="pr-6">
                  <CampoFormularioDatos nombre-campo="pro" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
                <v-col cols="4">
                  <CampoFormularioDatos nombre-campo="pai" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
              </v-row>
              <v-row  no-gutters>
                <v-col cols="6" class="pr-6">
                  <CampoFormularioDatos nombre-campo="corele" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
                <v-col cols="3" class="pr-6">
                  <CampoFormularioDatos nombre-campo="tel1" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
                <v-col cols="3">
                  <CampoFormularioDatos nombre-campo="tel2" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"/>
                </v-col>
              </v-row>
              <v-row no-gutters class="mb-n2">
                <v-col cols="12">
                  <CampoFormularioDatos nombre-campo="obs" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- D A T O S -->
          <v-tab-item transition="scroll-x-transition" eager>
            <v-container class="mt-5 px-6">
              <v-row>
                <v-col class="pb-0">
                  <CampoFormularioDatos ref="id_tippas" nombre-campo="id_tippas" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"  @change="changeSelectTipoPase" />
                  <v-row no-gutters v-show="numeroPlazaVisible">
                    <v-col cols="6">
                      <CampoFormularioDatos nombre-campo="numpla" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :disabled="!datosRegistro ['id_tippas']" />
                    </v-col>
                  </v-row>

                  <div style="font-size: 12px">{{ $t ('Estado de presencia') }}</div>
                  <v-radio-group id="presente" v-model="datosRegistro.id_estpre" row class="mt-n1" :readonly="!$store.operador.atributosRol.includes ('modestprepas')" :disabled="!datosRegistro ['id_tippas']">
                    <v-radio :label="$t ('Indefinido')" color="#AAAAAA" :value="0" />
                    <v-radio :label="$t ('Ausente')" color="#50779f" :value="1" />
                    <v-radio :label="$t ('Presente')" color="#509F50" :value="3" @click="mostrarMenuZonas" />
                    <v-menu
                      v-model="menuZonasVisible"
                      fixed
                      :absolute="false"
                      :position-x="xMenuZonas"
                      :position-y="yMenuZonas"
                    >
                      <v-list>
                        <v-list-item dense v-for="(descripcion, valor) in definicionCampos['id_zon_pre'].dominio_valores" :key="valor" @click="clickZonaPresenciaPase (JSON.parse (valor), descripcion)">
                          <v-list-item-title>{{descripcion}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>

                    <span v-if="datosRegistro.id_estpre == 3" class="text-caption"><strong>{{datosRegistro['id_zon_pre__VT']}}</strong></span>
                  </v-radio-group>

                  <v-row dense class="mt-n3 mb-2">
                    <v-col v-if="$store.operador.atributosRol.includes ('modapbpas')" cols="6"><CampoFormularioDatos nombre-campo="apb" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :disabled="!datosRegistro ['id_tippas']" /></v-col>
                    <v-col cols="6"><CampoFormularioDatos nombre-campo="blo" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :disabled="!datosRegistro ['id_tippas']" /></v-col>
                  </v-row>

                  <CampoFormularioDatos :min="fechaActual" :max="fechaFinValidez" nombre-campo="inival" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :disabled="!datosRegistro ['id_tippas']" :ajustar-segundos="0" :ajustar-milisegundos="0" hora-por-defecto="00:00" />
                  <CampoFormularioDatos :min="fechaInicioValidez" nombre-campo="finval" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :disabled="!datosRegistro ['id_tippas']" :ajustar-segundos="59" :ajustar-milisegundos="998" hora-por-defecto="23:59" />
                  <v-row no-gutters>
                    <v-col cols="4">
                      <CampoFormularioDatos v-if="literalMagnitudTipoSaldo (datosRegistro.tipsal)" nombre-campo="saldis" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :disabled="!datosRegistro ['id_tippas']" :suffix="literalMagnitudTipoSaldo (datosRegistro.tipsal)" />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6" class="pb-0">
                  <!-- L I S T A   D E   I D E N T I F I C A D O R E S -->
                  <div class="mt-n3 mb-2">{{ $t ('Lista de identificadores') }}</div>
                  <TablaDatosAPI
                    icono="mdi-shield-check"
                    tabla="idepas"
                    :campos="['id_tipidepas', 'ide']"
                    :parametros="parametros_idepas"
                    modo-memoria
                    titulo-crud="identificador de pase"
                    :permitir-anadir="!esAccionEliminar"
                    :permitir-modificar="!esAccionEliminar"
                    :permitir-eliminar="!esAccionEliminar"
                    :formulario-datos-api-props="{ anchoMaximo: '400' }"
                    dense
                    @cambios="cambiosEnIdentificadores (datosRegistro)"
                    @montado="montadoTablaDatos"
                    :evento-antes-guardar-formulario-datos="comprobarDuplicadoIdentificadorPase"
                    >
                    <template v-slot:[`item.ide`]="{ item }">
                        <span style="font-family: monospace">{{ item.ide }}</span>
                    </template>
                    <template v-slot:default="{ definicionCampos, datosRegistro, esAccionEliminar }">
                      <CampoFormularioDatos nombre-campo="id_tipidepas" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" @change="datosRegistro.ide ? datosRegistro.ide  = null : datosRegistro.ide = datosRegistro.ide" />
                      <CampoFormularioDatos v-show="datosRegistro.id_tipidepas == 10" nombre-campo="ide" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" label="Matrícula" prepend-inner-icon="mdi-car" :inputfilter="{ mayusculas: true, expresionRegular: ['[^0-9A-Za-z]', 'g'], longitudMaxima: 12 }" />
                      <CampoFormularioDatos v-show="datosRegistro.id_tipidepas == 20" nombre-campo="ide" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" label="Código de barras" prepend-inner-icon="mdi-barcode" :inputfilter="{ limpiarPorLaIzquierda: true, limpiarPorLaDerecha: true }" />
                      <span v-show="datosRegistro.id_tipidepas == 30" :readonly="esAccionEliminar">
                        <CampoFormularioDatos nombre-campo="ide" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" label="Nº de serie Tarjeta" prepend-inner-icon="mdi-smart-card-outline" :inputfilter="{ mayusculas: true, expresionRegular: ['[^0-9A-Fa-f]', 'g'], longitudMaxima: 12 }" />
                        <v-btn v-if="!esAccionEliminar" class="d-block mx-auto mt-n2 mb-4" :loading="leyendoNumeroSerieTP" @click="leerNumeroSerieTP (datosRegistro)" color="primary" text><v-icon left>mdi-credit-card-wireless-outline</v-icon>Leer tarjeta</v-btn>
                      </span>
                      <CampoFormularioDatos v-show="datosRegistro.id_tipidepas == 31" nombre-campo="ide" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" label="Otro Id. contactless" prepend-inner-icon="mdi-cellphone-wireless" :inputfilter="{ mayusculas: true, expresionRegular: ['[^0-9A-Fa-f]', 'g'], longitudMaxima: 16 }" />
                      <CampoFormularioDatos v-show="datosRegistro.id_tipidepas == 40" nombre-campo="ide" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" label="Nº de serie TAG" prepend-inner-icon="mdi-credit-card-wireless-outline" :inputfilter="{ expresionRegular: ['[^0-9A-Za-z]', 'g'], longitudMaxima: 30 }" />
                      <CampoFormularioDatos v-show="datosRegistro.id_tipidepas == 50" nombre-campo="ide" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" label="PIN" prepend-inner-icon="mdi-dialpad" :inputfilter="{ expresionRegular: ['[^0-9]', 'g'], longitudMaxima: 6 }" />
                      <CampoFormularioDatos v-show="datosRegistro.id_tipidepas > 50" nombre-campo="ide" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" prepend-inner-icon="mdi-identifier" />
                      <CampoFormularioDatos nombre-campo="obs" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                    </template>
                  </TablaDatosAPI>
                  <div style="height: 15px"></div>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- R E N O V A C I O N E S -->
          <v-tab-item v-if="registro_tipo_pase && registro_tipo_pase.tipren > 0" transition="scroll-x-transition" style="max-height: 60vh; overflow-y: auto" eager>
            <v-container class="mt-5 px-6">
              <v-row>
                <v-col >
                  <div class="mt-n3 mb-2">{{ $t ('Renovaciones') }}</div>
                  <TablaDatosAPI
                    icono="mdi-calendar-range"
                    tabla="renpas"
                    :campos="['initra+', 'fintra+', 'obs', 'imp', 'pag']"
                    :parametros="parametros_renpas"
                    modo-memoria
                    titulo-crud="renovación"
                    :permitir-anadir="!esAccionEliminar"
                    :permitir-modificar="!esAccionEliminar"
                    :permitir-eliminar="!esAccionEliminar"
                    :formulario-datos-api-props="{ anchoMaximo: '400' }"
                    dense
                    @cambios="cambiosEnRenovaciones (datosRegistro)"
                    @montado="montadoTablaDatos"
                    :evento-antes-abrir-formulario-datos="antesAbrirFormularioRenovacionesPase"
                    >
                    <template v-slot:default="{ definicionCampos, datosRegistro, accionCrud, esAccionEliminar }">
                      <CampoFormularioDatos nombre-campo="id_traren" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" @change="changeTramoRenovacion" />
                      <CampoFormularioDatos nombre-campo="initra" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar"  @change="changeInicioRenovacion" />
                      <CampoFormularioDatos nombre-campo="fintra" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                      <CampoFormularioDatos nombre-campo="obs" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                      <CampoFormularioDatos nombre-campo="imp" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                      <CampoFormularioDatos v-if="'UD'.includes (accionCrud)" nombre-campo="pag" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" readonly />
                      <CampoFormularioDatos v-if="'UD'.includes (accionCrud)" nombre-campo="codfac" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" readonly />
                    </template>
                  </TablaDatosAPI>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <!-- R E G I S T R O   D E   E V E N T O S -->
          <v-tab-item transition="scroll-x-transition" style="max-height: 60vh; overflow-y: auto">
            <TablaRegistroEventos
              titulo=""
              icono=""
              busqueda-rapida
              :parametros="parametros_regeve"
              :campos="['fechor', 'id_ins', 'id_apa', 'id_tipeve', '__datadi', 'matrec', 'salcon-', 'saldis-']"
              :campos-filtrables="['fechor', 'id_ins', 'id_tipeve']"
              :filas-por-pagina="200"
              :zoom="0.92"
              ocultar-pie
              dense
              sin-sombra
            />
          </v-tab-item>
        </v-tabs-items>
      </template>

    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from '@/components/CampoFormularioDatos.vue'
import { DateTime } from "luxon";
import api from '@/api'
import LectorProximidad from "@/lectorProximidad"
import TablaRegistroEventos from "@/components/TablaRegistroEventos.vue";
import utilAris from "@/utilAris";

export default {
  components: { TablaDatosAPI, CampoFormularioDatos, TablaRegistroEventos },
  data() {
    return {
      tab: 0,
      tablasDatos: [],
      menuZonasVisible: false,
      xMenuZonas: 0,
      yMenuZonas: 0,
      leyendoNumeroSerieTP: false,
      registro_tipo_pase: {}
    }
  },
  methods: {
    esFechaHoraPasada (fechaHoraSQL) {
      return DateTime.fromSQL (fechaHoraSQL) < DateTime.now();
    },
    esFechaHoraFutura (fechaHoraSQL) {
      return DateTime.fromSQL (fechaHoraSQL) > DateTime.now();
    },
    actualizarTiposDePases() {
      this.changeSelectEmpresaInquilina (this.tablasDatos['pas'].formulario.datosRegistro ["id_empinq"], this.tablasDatos['pas'].formulario.datosRegistro, this.tablasDatos['pas'].formulario.definicionCampos);
    },
    actualizarPlazasDisponiblesTipoPase() {
      this.changeSelectTipoPase (this.tablasDatos['pas'].formulario.datosRegistro ["id_tippas"], this.tablasDatos['pas'].formulario.datosRegistro, this.tablasDatos['pas'].formulario.definicionCampos);
    },
    changeSelectEmpresaInquilina (id_empinq, registro, definicionCampos) {
      // debemos actualizar el select de "tipos de pase" cada vez que cambie la empresa inquilina:
      definicionCampos ['id_tippas'].dominio_valores = {};
      api.obtenerTiposPases({ _contexto: 'gestion_pases', id_empinq: id_empinq })
        .then ( (respuesta) => {
          respuesta.data.filas.forEach (fila => {
            definicionCampos ['id_tippas'].dominio_valores [fila.id_tippas] = fila._des;
          });
          definicionCampos ['id_tippas'].dominio_valores [null] = this.$t ('(Sin especificar)');
          this.$refs['id_tippas'].actualizarItemsSelect();
        });
    },
    changeSelectTipoPase (id_tippas, registro, definicionCampos) {
      //this.registro_tipo_pase = this.$tablasConsulta.localizarRegistro ('tippas', {id_tippas: id_tippas});
      this.$set (this, 'registro_tipo_pase', this.$tablasConsulta.localizarRegistro ('tippas', {id_tippas: id_tippas}));

      definicionCampos ['numpla'].obligatorio = this.registro_tipo_pase && (this.registro_tipo_pase.forasipla == 1);
      this.tablasDatos['pas'].formulario.reiniciarEstadoValidacionCampos();

      definicionCampos ['numpla'].valores = [];
      api.obtenerPlazasDisponiblesTipoPase ({ id_empinq: this.tablasDatos['pas'].formulario.datosRegistro ["id_empinq"],
                                              id_tippas: id_tippas,
                                              numplaact: this.tablasDatos['pas'].formulario.datosRegistro ["numpla"] })
        .then ( (respuesta) => {
          respuesta.data.plazas.forEach (plaza => {
            definicionCampos ['numpla'].valores [JSON.stringify (plaza)] = plaza;
          });
          this.$refs['numpla'][0].actualizarItemsSelect();
        });
    },
    changeTramoRenovacion (id_traren, datosRegistro) {
      let infoTramoRenovacion = JSON.parse (this.tablasDatos ['renpas'].definicionCampos ['id_traren'].dominio_valores_extra [id_traren]);
      if (!datosRegistro ['initra'])
        this.$set (datosRegistro, 'initra', DateTime.local().plus({ days: 7 }).startOf ('month').toFormat('yyyy-MM-dd HH:mm:ss'));
      this.changeInicioRenovacion (datosRegistro ['initra'], datosRegistro);
      this.$set (datosRegistro, 'imp', infoTramoRenovacion.imp);
    },
    changeInicioRenovacion (initra, datosRegistro) {
      let infoTramoRenovacion = JSON.parse (this.tablasDatos ['renpas'].definicionCampos ['id_traren'].dominio_valores_extra [datosRegistro ['id_traren']]);
      this.$set (datosRegistro, 'fintra', DateTime.fromSQL (datosRegistro ['initra']).plus({ months: infoTramoRenovacion.plames, days: -1 }).endOf('day').toFormat('yyyy-MM-dd HH:mm:ss'));
    },
    antesAbrirFormularioDatosPase (formularioDatos) {
      this.tab = 0;
      this.actualizarTiposDePases();
      this.actualizarPlazasDisponiblesTipoPase();
      formularioDatos.definicionCampos['corele'].obligatorio = this.$parametros_configuracion ['forcorelepas'];
    },
    despuesGuardarFormularioDatosPase (formularioDatosAPI) {
      api.loteCambiosRegistrosTablaVista ('idepas', this.tablasDatos ['idepas'].loteCambiosRegistros((registro) => { registro.id_pas = formularioDatosAPI.datosRegistro ['id_pas'] }));
      if (this.tablasDatos ['renpas'])
        api.loteCambiosRegistrosTablaVista ('renpas', this.tablasDatos ['renpas'].loteCambiosRegistros((registro) => { registro.id_pas = formularioDatosAPI.datosRegistro ['id_pas'] }));
    },
    cambiosEnIdentificadores (datosRegistroPase) {
      if (this.tablasDatos ['idepas'].hayCambiosModoMemoria())
        this.$set (datosRegistroPase, 'cti__AUX', true); // cti = Cambios en Tabla de Identificadores
      else
        this.$delete (datosRegistroPase, 'cti__AUX');
    },
    montadoTablaDatos (tablaDatos) {
      this.tablasDatos [tablaDatos.tabla] = tablaDatos;
    },
    mostrarMenuZonas (e) {
      if (this.$store.operador.atributosRol.includes ('modestprepas')) {
        this.xMenuZonas = e.clientX;
        this.yMenuZonas = e.clientY;
        this.menuZonasVisible = true;
      }
    },
    clickZonaPresenciaPase(valor, descripcion) {
      this.tablasDatos['pas'].formulario.datosRegistro['id_zon_pre'] = valor;
      this.tablasDatos['pas'].formulario.datosRegistro['id_zon_pre__VT'] = descripcion;
    },
    leerNumeroSerieTP (datosRegistro) {
      this.leyendoNumeroSerieTP = true;
      datosRegistro.ide = "";
      LectorProximidad.leerNumeroSerie (5000)
        .then ((respuesta) => {
          datosRegistro.ide = respuesta;
        })
        .catch (() => {
          datosRegistro.ide = "";
        })
        .finally(() => {
          this.leyendoNumeroSerieTP = false;
        });
    },
    antesAbrirFormularioRenovacionesPase (formularioDatos) {
      formularioDatos.datosRegistro ['id_tippas__AUX'] = this.registro_tipo_pase.id_tippas;
    },
    cambiosEnRenovaciones (datosRegistroPase) {
      if (this.tablasDatos ['renpas'].hayCambiosModoMemoria())
        this.$set (datosRegistroPase, 'ctr__AUX', true); // ctr = Cambios en Tabla de Renovaciones
      else
        this.$delete (datosRegistroPase, 'ctr__AUX');
    },
    async comprobarDuplicadoIdentificadorPase (formularioDatos, arrayCambiosEnRegistro) {
      if (arrayCambiosEnRegistro.id_tipidepas || arrayCambiosEnRegistro.ide) {
        let respuesta = await api.obtenerDisponibilidadIdentificadorPase ({ id_tipidepas: formularioDatos.datosRegistro.id_tipidepas, ide: formularioDatos.datosRegistro.ide});
        if (respuesta.data.identificador_pase) {
          let registro = respuesta.data.identificador_pase;
          if (registro.id_pas != formularioDatos.datosRegistro.id_pas) {
            let texto = 'El identificador "' + formularioDatos.datosRegistro.ide + '" ya pertenece a otro pase.';
            if (registro.empinq_nom)
              texto += " | Empresa inquilina: " + registro.empinq_nom;
            if (registro.tit)
              texto += " | Titular: " + registro.tit;
            this.$cuadroDeDialogo.mostrar ('Identificador duplicado', texto, ['Aceptar']);
            return false;
          }
        }
      }
      return true;
    },
    ...utilAris,
  },
  computed: {
    parametros_idepas() {
      return {
        idPase: { valor: this.tablasDatos['pas'].formulario.datosRegistro ['id_pas'] ? this.tablasDatos['pas'].formulario.datosRegistro ['id_pas'] : 0,
                  descripcion: '' }
      };
    },
    parametros_renpas() {
      return {
        idPase: { valor: this.tablasDatos['pas'].formulario.datosRegistro ['id_pas'] ? this.tablasDatos['pas'].formulario.datosRegistro ['id_pas'] : 0,
                  descripcion: '' }
      };
    },
    parametros_regeve() {
      return {
        idPase: { valor: this.tablasDatos['pas'].formulario.datosRegistro ['id_pas'] ? this.tablasDatos['pas'].formulario.datosRegistro ['id_pas'] : 0,
                  descripcion: this.$t ('Pase')+': ' + this.tablasDatos['pas'].formulario.datosRegistro ['nomape'] }
      };
    },
    fechaActual() {
      return DateTime.local().toISODate();
    },
    fechaInicioValidez() {
      if (this.tablasDatos['pas'].formulario.datosRegistro ['inival'])
        return DateTime.fromFormat (this.tablasDatos['pas'].formulario.datosRegistro ['inival'], "yyyy-MM-dd HH:mm:ss").toISODate();
      else
        return DateTime.fromObject({ year: 1979, month: 4, day: 30}).toISODate();
    },
    fechaFinValidez() {
      if (this.tablasDatos['pas'].formulario.datosRegistro ['finval'])
        return DateTime.fromFormat (this.tablasDatos['pas'].formulario.datosRegistro ['finval'], "yyyy-MM-dd HH:mm:ss").toISODate();
      else
        return "";
    },
    numeroPlazaVisible () {
      let id_tippas = this.tablasDatos['pas'].formulario.datosRegistro ['id_tippas'];
      if (!this.tablasDatos['pas'].formulario.definicionCampos['id_tippas'].dominio_valores_extra)
        return true;
      let json = this.tablasDatos['pas'].formulario.definicionCampos['id_tippas'].dominio_valores_extra [id_tippas];
      if (json)
        return !JSON.parse (json).usoconres;
      else
        return true;
    }
  },
  mounted() {
    this.$tablasConsulta.actualizar();
  }
};
</script>

<style>
v-row > v-col {
  background: red;
}
</style>